import api from '@/services/api'

export default {
  state: {},

  mutations: {},

  actions: {
    async saveUpdateMemoriaCalculo({ commit }, data) {
      try {
        return await api.post(
          `/centros-custos/${data.codCCustoPai}/filhos/orcamento/${data.orcamentoId}/${data.codCCustoFilho}/memorias-calculos`,
          data.memoriaCalculo,
        )
      } catch (error) {
        throw error
      }
    },

    async getMemoriaCalculo({ commit }, filters) {
      try {
        const response = await api.get(
          `/centros-custos/${filters.codCCustoPai}/filhos/orcamento/${filters.orcamentoId}/${filters.codCCustoFilho}/memorias-calculos?codTBOrcamento=${filters.codTBOrcamento}&mes=${filters.mes}`,
        )

        return response && response.data ? response.data : null
      } catch (error) {
        throw error
      }
    },
  },

  getters: {},
}
